import script from "./QuestionsUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsUpload.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsUpload.vue?vue&type=style&index=0&id=0204de33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0204de33"]])

export default __exports__